import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    selectedChat: null,
    assignedTo: undefined,
    states: ["BOT", "ASSIGNED"],
};
const chatsSlice = createSlice({
    name: "chats",
    initialState,
    reducers: {
        setAssignedTo(state, action) {
            state.assignedTo = action.payload;
        },
        setStates(state, action) {
            state.states = action.payload;
        },
        setSelectedChat(state, action) {
            state.selectedChat = action.payload;
        },
    },
});
export const { setAssignedTo, setStates, setSelectedChat } = chatsSlice.actions;
export default chatsSlice.reducer;
export const chatsSelector = (state) => state.chats;
